document.addEventListener('DOMContentLoaded', () => {
  const bundleButton = document.querySelector('.bundle-add');

  if (!bundleButton) return;

  bundleButton.addEventListener('click', async () => {
    const productForm = document.querySelector('form[action*="/cart/add"]');

    if (!productForm) {
      alert('Product form not found');
      return;
    }

    const formData = new FormData(productForm);

    const bundleItems = [];

    document.querySelectorAll('.bundle-item').forEach(item => {
      const checkbox = item.querySelector('.bundle-checkbox');
      const title = item.querySelector('.bundle-title');
      const select = item.querySelector('.bundle-select');

      if (!checkbox || !checkbox.checked || !title || !select) return;

      const selectedOption = select.options[select.selectedIndex];

      bundleItems.push(
        `${title.textContent.trim()} - ${selectedOption.textContent.trim()}`
      );
    });

    bundleItems.forEach((item, index) => {
      formData.append(`properties[Bundle Item ${index + 1}]`, item);
    });

    bundleButton.classList.add('loading');
    bundleButton.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Could not add product');
      }

      bundleButton.classList.remove('loading');
      bundleButton.textContent = 'Added ✓';

      setTimeout(() => {
        bundleButton.textContent = 'Add the bundle to cart';
      }, 2000);

    } catch (error) {
      console.error(error);

      alert('Please select all required options first.');

      bundleButton.classList.remove('loading');
      bundleButton.textContent = 'Add the bundle to cart';
    }
  });
});